import React, { useState } from 'react';
import BackRow from 'components/BackRow/BackRow';
import { DeleteDialog, MessageDialog } from 'components/Dialog/Dialog';
import WorshipLocationItem from './WorshipLocationItem';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import { post, dodelete, put } from 'lib/comms';

const WorshipLocationsPage = (props) => {
    const isNew = props.worship && props.worship.id === 'new';
    const worshipInit = isNew
        ? {
              id: 'new',
              title: '',
              description: '',
              details: '',
              location: '',
              religion: 1,
              phone: null,
              active: 1,
              email_address: 0,
          }
        : props.worship;

    const [state, setState] = useState({
        worship: worshipInit,
        editing: [isNew],
        showDeleteDialog: false,
        showMessage: null,
        isNew,
    });

    const setEditing = async (index) => {
        let { editing, worship } = state;
        if (editing[index]) {
            // save to db
            if (!worship.title) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid title', title: 'Save Worship location' },
                });
            }
            if (!worship.description) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid description', title: 'Save Worship location' },
                });
            }

            if (!worship.details) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid details', title: 'Save Worship location' },
                });
            }

            if (!worship.location) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid location', title: 'Save Worship location' },
                });
            }

            if (worship.email_address && !isEmail(worship.email_address)) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid email address', title: 'Save Worship location' },
                });
            }

            if (!worship.religion || worship.religion === 'select') {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid religion', title: 'Save Worship location' },
                });
            }

            if (
                worship.phone &&
                (!worship.phone.match(
                    /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/,
                ) ||
                    worship.phone.length > 16)
            ) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid phone', title: 'Save Worship location' },
                });
            }

            let resp = null;
            if (worship.id === 'new') {
                resp = await post('cms/worship_location', worship, true);
            } else {
                resp = await put(`cms/worship_location/${worship.id}`, worship, true);
            }

            if (resp && resp.success && resp.worshipLocation) {
                props.reload();
                editing[index] = false;
                if (resp.worshipLocation.id) {
                    editing[1] = true;
                    worship.id = resp.worshipLocation.id;
                    props.updateItemCreated();
                    setState({ ...state, worship, isNew: false });
                }
            } else console.log(resp);
            if (resp.message) {
                setTimeout(
                    () => setState({ ...state, showMessage: { message: resp.message, title: 'Save error' } }),
                    500,
                );
            }
            editing[index] = false;
        } else editing[index] = true;
        setState({ ...state, editing });
    };

    const doDelete = async () => {
        const resp = await dodelete('cms/worship_location', { id: state.worship.id }, true);
        if (resp && resp.success && props.onBack) {
            setState({ ...state, worship, isNew: false, showDeleteDialog: false });
            props.reload('back');
        } else if (resp.message) {
            setTimeout(
                () => setState({ showMessage: { message: resp.message, title: 'Delete worship location' } }),
                500,
            );
        }
    };

    let { worship, editing } = state;

    return (
        <div className="maincontainer">
            <BackRow
                onBack={props.onBack}
                buttonTitle={state.isNew ? '' : 'DELETE WORSHIP LOCATION'}
                onDelete={() => setState({ ...state, showDeleteDialog: true })}
            />

            <WorshipLocationItem
                worship={worship}
                editing={editing[0]}
                onToggle={() => setEditing(0)}
                onEdit={(what) => setState({ ...state, worship: { ...worship, ...what } })}
            />
            {state.showDeleteDialog ? (
                <DeleteDialog
                    item="Worship"
                    onSuccess={doDelete}
                    onClose={() => setState({ ...state, showDeleteDialog: false })}
                />
            ) : null}
            {state.showMessage ? (
                <MessageDialog
                    message={state.showMessage.message}
                    title={state.showMessage.title}
                    onClose={() => setState({ ...state, showMessage: null })}
                />
            ) : null}
        </div>
    );
};

export default WorshipLocationsPage;
